import { useQuery } from 'react-query';
import { workersPoolsService } from 'ogp/services';
import { QUERY_KEYS } from 'api/query-keys';
import type { FlexWorkerItem } from '../../../../flex-pool-detail/components/flex-workers/flex-workers.types';

export const useGetWorkersPoolFlexWorkers = (workersPoolId: string, flexWorkerName?: string) => {
  const queryFn = async () =>
    await workersPoolsService.getWorkersPoolFlexWorkers(workersPoolId, flexWorkerName);

  return useQuery<FlexWorkerItem[], Error, FlexWorkerItem[]>(
    QUERY_KEYS.externalWorkersPoolFlexWorkers(workersPoolId, flexWorkerName),
    queryFn,
    {
      enabled: workersPoolId.length > 0,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );
};
